import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/dist/js/bootstrap.bundle.min";  

const Home = () => {
    return (
        <header className="App-header">
        <p>
          Website under construction. Please check back later.
        </p>
        <a
          className="App-link"
          href="https://www.instagram.com/imagegroupllc"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
      </header>
    );
};

export default Home;